import { NbMenuItem } from "@nebular/theme";

export const MENU_ITEMS: NbMenuItem[] = [
        {
          title: 'Latest',
          link: '/news/latest',
        },
        {
          title: 'Community Updates',
          link: '/news/communityUpdates',
        },
        {
          title: "Product Updates",
          link: '/news/productUpdates',
        },
        {
          title: "Partnership",
          link: '/news/partnership',
        },
        {
          title: "Learn",
          link: '/news/learn',
        },
        {
          title: "Staking",
          link: '/news/staking',
        }
      
    
    ]